module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pXI"
    }
  }, [_vm._v("Illustrations")])]), _c('a', {
    attrs: {
      "id": "pXI"
    }
  }, [_c('p', {
    staticClass: "ahd1"
  }, [_vm._v("Plates")])]), _c('div', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "id": "pXI"
    }
  }), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "id": "pXI"
    }
  }), _c('a', {
    attrs: {
      "href": "#/008Plates#plate1"
    }
  }, [_vm._v("1.")]), _vm._v(" Johannes Hevelius, Sunspot observations in Danzig, 1642–4. Source: Hevelius, "), _c('i', [_vm._v("Selenographia")]), _vm._v(" (Danzig, 1647), fig. 3. The Thomas Fischer Rare Book Library, University of Toronto.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate2"
    }
  }, [_vm._v("2.")]), _vm._v(" Leonhard Kern, "), _c('i', [_vm._v("Scene from the Thirty Years War,")]), _vm._v(" 1640s"), _c('i', [_vm._v(".")]), _vm._v(" Source: Kunsthistorisches Museum, Vienna (KK 4363).")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate3"
    }
  }, [_vm._v("3.")]), _vm._v(" King Charles I exchanges his worldly crown for a crown of thorns, 1649. Source:"), _c('i', [_vm._v(" Eikōn Basilikē")]), _vm._v(", 1649, frontispiece by William Marshall. The Huntington Library, San Marino, California (RB 121950).")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate4"
    }
  }, [_vm._v("4.")]), _vm._v(" Zacharias Wagenaer, Drawing of the city of Edo on 4 March 1657 after the fire, 1651. Source: Edo-Tokyo Museum, Tokyo.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate5"
    }
  }, [_vm._v("5.")]), _vm._v(" Yang Dongming, "), _c('i', [_vm._v("Jimin tushuo")]), _vm._v(" ["), _c('i', [_vm._v("Album of the Famished")]), _vm._v("], 1688. Source: By kind permission of Henan Provincial Museum.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate6"
    }
  }, [_vm._v("6.")]), _vm._v(" A letter left with an abandonned baby, 1628. Source: AHN Consejos, 41,391, unfol.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate7"
    }
  }, [_vm._v("7.")]), _vm._v(" Weather in China, 1640 and 1641. Source: "), _c('i', [_vm._v("Zhongguo Jin-wubai-nian Hanlao Fenbu Tu-ji")]), _vm._v(", 91.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate8"
    }
  }, [_vm._v("8.")]), _vm._v(" A Chinese male undergoes ‘tonsorial castration’, 1843. Source: Rev. G. N. Wright, "), _c('i', [_vm._v("China")]), _vm._v(", III, 50. © The British Library Board (Maps 10.bb.31).")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate9"
    }
  }, [_vm._v("9.")]), _vm._v(" ‘The Wine Jew’, Germany, 1629. Source: Germanisches Nationalmuseum (HB 2057, Kapsel 1279).")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate10"
    }
  }, [_vm._v("10.")]), _vm._v(" The salt register for Calle Fuencarral, Madrid, 1631. Source: BNE Ms 6760. Courtesy of the Biblioteca National de España.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate11"
    }
  }, [_vm._v("11.")]), _vm._v(" Spanish stamp duty ("), _c('i', [_vm._v("Papel Sellado")]), _vm._v("). Source: Hispanic Society of America, "), _c('i', [_vm._v("Altamira Papers")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate12"
    }
  }, [_vm._v("12.")]), _vm._v(" A consulta signed by Philip IV, 7 December 1640. Source: AGS GA 1331, unfol., Philip IV's rescript to a consulta from the "), _c('i', [_vm._v("Junta de Ejecució")]), _vm._v("n, 7 December 1640. España, Ministerio de Cultura, Archivo General de Simancas.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate13"
    }
  }, [_vm._v("13.")]), _vm._v(" Wenceslaus Hollar, "), _c('i', [_vm._v("The British Civil Wars and the Revolt of Bohemia")]), _vm._v(", 1632. Source: Wenceslaus Hollar, "), _c('i', [_vm._v("Map of Civil War England and a View of Prague")]), _vm._v(", 1632. Private Collection/The Bridgeman Art Library.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate14"
    }
  }, [_vm._v("14.")]), _vm._v(" ‘The Arch-Prelate of St Andrews in Scotland reading the new service book in his pontificalious assaulted by men & women, with crickett tooles sticks and stones’, 1637. Source: Private Collection/The Bridgeman Art Library.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate15"
    }
  }, [_vm._v("15.")]), _vm._v(" Wenceslaus Hollar, The earl of Strafford's impeachment in Westminster Hall, 1641. Source: The Thomas Fischer Rare Book Library, University of Toronto.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "id": "pXII"
    }
  }), _c('a', {
    attrs: {
      "href": "#/008Plates#plate16"
    }
  }, [_vm._v("16.")]), _vm._v(" ‘Now are ye wilde Irisch as well as wee’, 1655. Source: Anon., "), _c('i', [_vm._v("The Barbarous and Inhumane Proceedings Against the Professors of the Reformed Religion")]), _vm._v(" (London, 1655), 13. The Huntington Library, San Marino, California (RB 16167).")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate17"
    }
  }, [_vm._v("17.")]), _vm._v(" Yang Dongming, "), _c('i', [_vm._v("Jimin tushuo")]), _vm._v(" ["), _c('i', [_vm._v("Album of the Famished")]), _vm._v("], 1688. Source: By kind permission of Henan Provincial Museum.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate18"
    }
  }, [_vm._v("18.")]), _vm._v(" Micco Spadaro, "), _c('i', [_vm._v("The revolt of Masaniello")]), _vm._v(", c. 1647. Source: Museo di San Martino, Naples. Photo Scala, Florence. Courtesy of the Ministero Beni e Att. Culturali.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate19"
    }
  }, [_vm._v("19.")]), _vm._v(" ‘The figure of the Indians’ fort or Palizado in New England And the marer of the destroying it by Captayne Underhill And Captayne Mason’, 1637. Source: John Underhill, "), _c('i', [_vm._v("Nevves from America")]), _vm._v(" (1638). Library of Congress, LC-USZ62-32055.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate20"
    }
  }, [_vm._v("20.")]), _vm._v(" Portion of a map of Edo, Japan. Source: University of Texas Libraries.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate21"
    }
  }, [_vm._v("21.")]), _vm._v(" Micco Spadaro, The Execution of Don Giuseppe Carafa, c. 1647. Source: Museo di San Martino, Naples. Photo Scala, Florence. Courtesy of the Ministero Beni e Att. Culturali.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate22"
    }
  }, [_vm._v("22.")]), _vm._v(" ‘Smoking kills’, 1658. Source: Jakob Balde, "), _c('i', [_vm._v("Die trückene Trünckenheit")]), _vm._v(" (Nuremberg, 1658), frontispiece.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate23"
    }
  }, [_vm._v("23.")]), _vm._v(" Frontispiece to Grimmelshausen, "), _c('i', [_vm._v("Der Abenteuerliche Simplicissimus")]), _vm._v(" ("), _c('i', [_vm._v("The Adventurous Simplicissimus")]), _vm._v("), 1668. Source: akg-images.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate24"
    }
  }, [_vm._v("24.")]), _vm._v(" Johan Niewhaf, "), _c('i', [_vm._v("Tiencenwey")]), _vm._v(", 1656. Source: Nieuhof, "), _c('i', [_vm._v("Die Gesantschaft der Ost-Indischen Geselschaft")]), _vm._v(", Heidelberg University Library, A4820, pull-out 28.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate25"
    }
  }, [_vm._v("25.")]), _vm._v(" "), _c('i', [_vm._v("A general Bill for this present year")]), _vm._v(", 1665. Source: Guildhall Library, London. Courtesy of the London Metropolitan Archives.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate26"
    }
  }, [_vm._v("26.")]), _vm._v(" Jan van de Heyden, A fire engine in action during a major freeze, Amsterdam, 1684. Source: "), _c('i', [_vm._v("Beschryving der nieuwlyks uitgevonden en geoctrojeerde slang-brand-spuiten en haare wyze van brand-blussen, tegenwoordig binnen Amsterdam in gebruik zijnde")]), _vm._v(" (Amsterdam, 1672), figure 16.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate27"
    }
  }, [_vm._v("27.")]), _vm._v(" "), _c('i', [_vm._v("Renatus Cartesius")]), _vm._v(", c. 1720. Source: Pieter van der Aa, "), _c('i', [_vm._v("XX icones clarissimorum medicorum Philosophorum Liberales Artes Profitentium Aliorumque")]), _vm._v(" (Leiden, c. 1720). Landesbibliothek Oldenburg.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate28"
    }
  }, [_vm._v("28.")]), _vm._v(" ‘A Scheme At one View representing to the Eye the Observations of the Weather for a Month’, 1663. Source: Sprat, "), _c('i', [_vm._v("History")]), _vm._v(", I, 179. © The British Library Board (740.c.17).")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd1"
  }, [_vm._v("Figures")]), _vm._v(" "), _c('div', {
    staticClass: "nl"
  }, [_c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/009Prologue_Did_Someone_Say_x2018Climate_Changex0027#fig_01"
    }
  }, [_vm._v("1.")]), _vm._v(" The Global Crisis.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0121_The_Little_Ice_Age#fig_02"
    }
  }, [_vm._v("2.")]), _vm._v(" Sunspot cycles, volcanic anomalies, and summer temperature variations in the seventeenth century. Source: Eddy, ‘The “Maunder Minimum”’, 290, figure 11–6; Vaquero, ‘Revised, sunspot data’, figure 2; and Atwell, ‘Volcanism’, Figures C5 and E3.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0121_The_Little_Ice_Age#fig_03"
    }
  }, [_vm._v("3.")]), _vm._v(" Estimated heights of French males born between 1650 and 1770. Source: Komlos, ‘Anthropometric history’, 180, "), _c('span', {
    attrs: {
      "href": "#/0175_The_x2018Great_Enterprisex2019_in_China_1618x201384#fig_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 16")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0132_The_x2018General_Crisisx2019#fig_04"
    }
  }, [_vm._v("4.")]), _vm._v(" Frequency of wars in Europe 1610–80")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_05"
    }
  }, [_vm._v("5.")]), _vm._v(" Farms in south-east Scotland abandoned in the seventeenth century. Source: Grove, "), _c('i', [_vm._v("Little Ice Age")]), _vm._v(", 409.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_06"
    }
  }, [_vm._v("6.")]), _vm._v(" The ‘dampening effect’ of London on England's overall demographic growth. Courtesy of Sir Tony Wrigley.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_07"
    }
  }, [_vm._v("7.")]), _vm._v(" The fires of Istanbul 1600–1700. Source: Atasoy and Raby, "), _c('i', [_vm._v("Iznik")]), _vm._v(", 16–17.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_08"
    }
  }, [_vm._v("8.")]), _vm._v(" The double-cropping cycle in Liangan southeast China. Source: Marks, "), _c('i', [_vm._v("Tigers")]), _vm._v(", 203.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "id": "pXIII"
    }
  }), _c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_09"
    }
  }, [_vm._v("9.")]), _vm._v(" A simple model of early modern economic systems. Courtesy of Kishimoto Mio.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_10"
    }
  }, [_vm._v("10.")]), _vm._v(" The social structure of Navalmoral, Spain, in the early seventeenth century. Source: Weisser, "), _c('i', [_vm._v("Peasants")]), _vm._v(", 38–42.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century#fig_11"
    }
  }, [_vm._v("11.")]), _vm._v(" The Mediterranean plague epidemic of 1648–56. Courtesy of Jorge Nadal.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century#fig_12"
    }
  }, [_vm._v("12.")]), _vm._v(" Mortality in Barcelona, 1650–4. Source: Betrán, "), _c('i', [_vm._v("La peste")]), _vm._v(", 73.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century#fig_13"
    }
  }, [_vm._v("13.")]), _vm._v(" Burials in Berkshire, England. Source: Dils, ‘Epidemics’, 148.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century#fig_14"
    }
  }, [_vm._v("14.")]), _vm._v(" A subsistence crisis: Geneva 1627–32. Source: Perrenoud, "), _c('i', [_vm._v("La population de Genève")]), _vm._v(", 443.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century#fig_15"
    }
  }, [_vm._v("15.")]), _vm._v(" Children abandoned at the Foundlings Hospital of Milan. Source: Hunecke, "), _c('i', [_vm._v("Die Findelkinder von Mailand")]), _vm._v(", 218 and 221.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0175_The_x2018Great_Enterprisex2019_in_China_1618x201384#fig_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.")]), _vm._v(" Ming China in the seventeenth century.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0175_The_x2018Great_Enterprisex2019_in_China_1618x201384#fig_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.")]), _vm._v(" Disasters and diseases cripple Ming China, 1641. Source: Dunstan, ‘Late Ming epidemics’, map 6; von Glahn, "), _c('i', [_vm._v("Fountain of fortune")]), _vm._v(", xiii.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0175_The_x2018Great_Enterprisex2019_in_China_1618x201384#fig_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.")]), _vm._v(" East Asian temperatures, 800–1800. Courtesy of Keith Briffa and Tim Osborn.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0186_x2018The_great_shakingx2019_Russia_and_the_PolishLithuanian_Commonwealth_1618x201386#fig_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.")]), _vm._v(" The Russian empire and the Polish-Lithuanian Commonwealth.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0197_The_x2018Ottoman_tragedyx2019_1618x201383#fig_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.")]), _vm._v(" The climatic zones of the Ottoman Empire. Source: Hütterroth, ‘Ecology’, 20.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0197_The_x2018Ottoman_tragedyx2019_1618x201383#fig_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21.")]), _vm._v(" Tax yields in the Balkans, Anatolia and Syria, 1640–1834. Source: McGowan, "), _c('i', [_vm._v("Economic life in Ottoman Europe")]), _vm._v(", 113.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0197_The_x2018Ottoman_tragedyx2019_1618x201383#fig_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22.")]), _vm._v(" The Ottoman empire at war, 1630–1700. Source: Mantran, "), _c('i', [_vm._v("Istanbul")]), _vm._v(", 260.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0208_The_x2018lamentations_of_Germanyx2019_and_its_Neighbours_1618x201388#fig_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23.")]), _vm._v(" The rhythm of pamphlet publication in Germany, 1618–50.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0208_The_x2018lamentations_of_Germanyx2019_and_its_Neighbours_1618x201388#fig_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24.")]), _vm._v(" The depopulation of Germany during the Thirty Years War, 1618–48. Source: Franz, "), _c('i', [_vm._v("Der dreissigjähriger Krieg,")]), _vm._v(" 4th edn, 8.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389#fig_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25.")]), _vm._v(" The revolt of Portugal, 1637. Source: Schaub, "), _c('i', [_vm._v("Le Portugal")]), _vm._v(", 491.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389#fig_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26.")]), _vm._v(" Catalonia in revolt, May 1640. Source: "), _c('i', [_vm._v("Atles d'Història de catalunya")]), _vm._v(", 157.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389#fig_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27.")]), _vm._v(" The subsistence crisis in Madrid, 1647–8. Source: Larquié, “Popular uprisings,” 97.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389#fig_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28.")]), _vm._v(" The ‘Green Banner’ revolts in Andalusia, 1647–52. Source: Domínguez Ortiz, "), _c('i', [_vm._v("Alteraciones andaluzas")]), _vm._v(", 51.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389#fig_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29.")]), _vm._v(" Baptisms in Castile, 1600–1700. Source: Nadal, ‘La población española’, 53–4.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388#fig_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30.")]), _vm._v(" Seventeenth-century France. Source: Bonney, "), _c('i', [_vm._v("Political change,")]), _vm._v(" 345.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388#fig_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31.")]), _vm._v(" Receipts from the "), _c('i', [_vm._v("taille")]), _vm._v(" by the French treasury, 1600–47. Source: Bonney, "), _c('i', [_vm._v("The rise of the fiscal state,")]), _vm._v(" 141.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388#fig_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32.")]), _vm._v(" Pamphlet publication in seventeenth-century France. Source: Duccini, 'Regard’, 323.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388#fig_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33.")]), _vm._v(" Monthly production of "), _c('i', [_vm._v("Mazarinades")]), _vm._v(", May 1649–July 1653. Source: Carrier, "), _c('i', [_vm._v("La presse")]), _vm._v(", I, 275.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388#fig_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34.")]), _vm._v(" War, climate and mortality in Ile-de-France during the seventeenth century. Source: Garnier, ‘Calamitosa tempora, 9, figure 4.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02311_The_Stuart_Monarchy_The_Path_to_Civil_War_1603x201342#fig_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35.")]), _vm._v(" Plan of the Palace of Westminster, England. Source: Jones and Kelsey, "), _c('i', [_vm._v("Housing Parliament")]), _vm._v(", ix.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389#fig_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36.")]), _vm._v(" Periodicals and newspapers published in England, 1620–75. Source: Crane and Kaye, "), _c('i', [_vm._v("A census")]), _vm._v(", 179–81.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389#fig_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37.")]), _vm._v(" Publications in seventeenth-century England. Source: Cressy, "), _c('i', [_vm._v("England on edge")]), _vm._v(", 293.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389#fig_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38.")]), _vm._v(" The redistribution of confiscated Irish land, 1653–60. Source: Bottigheimer, "), _c('i', [_vm._v("English money and Irish land")]), _vm._v(", 215.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02613_The_Mughals_and_their_Neighbours#fig_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39.")]), _vm._v(" The Mughal annual ‘radius of action’. Source: Gommans, "), _c('i', [_vm._v("Mughal warfare")]), _vm._v(", 108.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02613_The_Mughals_and_their_Neighbours#fig_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40.")]), _vm._v(" Drought and the seventeenth-century crisis in Indonesia. Source: Reid, ‘The crisis’, 213.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02714_Red_Flag_over_Italy#fig_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41.")]), _vm._v(" The kingdom of Naples in revolt, 1647–8. Source: Hugo, "), _c('i', [_vm._v("Naples")]), _vm._v(", 93.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia#fig_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42.")]), _vm._v(" Trade between Seville and America, 1500–1650. Source: Romano, "), _c('i', [_vm._v("Conjonctures opposées")]), _vm._v(", 162.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia#fig_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43.")]), _vm._v(" The southward advance of the Sahara from 1630. Source: Brooks, "), _c('i', [_vm._v("Landlords and strangers")]), _vm._v(", 10.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "id": "pXIV"
    }
  }), _c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia#fig_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44.")]), _vm._v(" Drought and disease in west-central Africa, 1560–1710. Source: Miller, ‘The significance of drought’, 21.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia#fig_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45.")]), _vm._v(" Famine and drought in Chad, Senegambia and the Niger Bend, 1500–1710. Source: Nicholson, ‘Methodology’, 45.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia#fig_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46.")]), _vm._v(" Slaves captured and shipped from Africa, 1600–1700. Courtesy of David Eltis.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02916_Getting_it_Right_Early_Tokugawa_Japan#fig_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47.")]), _vm._v(" The growth of publishing houses in Japan, 1591–1818. Source: Ikegami, "), _c('i', [_vm._v("Bonds of Civility")]), _vm._v(", 296.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03117_x2018Those_who_have_no_means_of_supportx2019_The_Parameters_of_Popular_Resistance#fig_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48.")]), _vm._v(" Collective violence in Ming China, 1368–1644. Source: Tong, "), _c('i', [_vm._v("Disorder under heaven")]), _vm._v(", 47.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03218_x2018People_who_hope_only_for_a_changex2019_Aristocrats_Intellectuals_Clerics_and_x2018dirty_people_of_no_namex2019#fig_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49.")]), _vm._v(" Universities founded in Europe, 1600–60. Source: H. de Ridder-Simoens, "), _c('i', [_vm._v("History of the university in Europe. II: early modern Europe")]), _vm._v(" (Cambridge, 1996), 98.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03319_x2018People_of_heterodox_beliefs_x2026_who_will_join_up_with_anyone_who_calls_themx2019_Disseminating_Revolution#fig_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50.")]), _vm._v(" Revolts in the Papal States in 1648. Source: Hugon, "), _c('i', [_vm._v("Naples")]), _vm._v(", 27.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/034PART_V_BEYOND_THE_CRISIS#fig_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51.")]), _vm._v(" ‘The Great Winter’ of 1708/9. Source: Lachiver, "), _c('i', [_vm._v("Les années de misère")]), _vm._v(", 274.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03621_From_Warfare_State_to_Welfare_State#fig_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52.")]), _vm._v(" An economy of integrated regions. Courtesy Kishimoto Mio.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03621_From_Warfare_State_to_Welfare_State#fig_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53.")]), _vm._v(" The conquest of plague in seventeenth-century Europe. Source: Lebrun, "), _c('i', [_vm._v("Se soigner autrefois")]), _vm._v(", 162–3.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03722_The_Great_Divergence#fig_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54.")]), _vm._v(" Henry Oldenburg's network of correspondents, 1641–77. Source: Hatch, ‘Between erudition and science’, 57.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03722_The_Great_Divergence#fig_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55.")]), _vm._v(" Sources of the information used by Newton in "), _c('i', [_vm._v("Principia Mathematica")]), _vm._v(" (1687). Source: Schaffer, "), _c('i', [_vm._v("The information order")]), _vm._v(", 23.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7587f2d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007List_of_Illustrations.vue
// module id = 72
// module chunks = 0